// extracted by mini-css-extract-plugin
export default {"addIcon":"styles_addIcon__9YEjJ"};